<template>
  <div id="app">
    <HeroBanner />
    <router-view />
  </div>
</template>

<script>
import HeroBanner from './components/HeroBanner'
export default {
  components: {
    HeroBanner
  }
}
</script>

<style lang="scss">
@import './styles/custom.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-bottom: 20rem;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
